import * as _ from 'lodash';
import Intersects from 'intersects';

import AreaObject from '@/assets/js/game/AreaObject';
import GameManager from '@/assets/js/game/GameManager';
import Player from '@/assets/js/game/Player';

const HIT_AREA_DIAMETER = 120;

const HIT_AREA_WIDTH_101 = 80;
const HIT_AREA_HEIGHT_101 = 80;

export default class AreaObjectEnemy extends AreaObject {
  constructor(objectData, x, y) {
    const image = objectData.image;
    const width = objectData.width;
    const height = objectData.height;
    super(objectData.id, width, height, x, y, image);

    this.isTurn = false;
  }

  setHitAreaSize() {
    if (this.id === 101) {
      const hitAreaWidth = GameManager.calcRatio(HIT_AREA_WIDTH_101);
      const hitAreaHeight = GameManager.calcRatio(HIT_AREA_HEIGHT_101);
      this.hitArea.x = this.sprite.x;
      this.hitArea.y = this.sprite.y + hitAreaHeight * 1.5;
      this.hitArea.width = hitAreaWidth;
      this.hitArea.height = hitAreaHeight;
      // this.hitArea.alpha = 0.4;
      // this.hitArea
      //   .beginFill(0xff00ff)
      //   .drawRect(0, 0, hitAreaWidth, hitAreaHeight)
      //   .endFill();
    } else {
      this.hitArea.radius = GameManager.calcRatio(HIT_AREA_DIAMETER) * 0.5;
      this.hitArea.x = this.sprite.x + this.sprite.width * 0.5;
      this.hitArea.y = this.sprite.y + this.sprite.height * 0.5;
      // this.hitArea.alpha = 0.4;
      // this.hitArea
      //   .beginFill(0xff00ff)
      //   .drawCircle(0, 0, this.hitArea.radius)
      //   .endFill();
    }
  }

  update(delta, viewPositionX) {
    const gameWidth = GameManager.calcRatio(GameManager.gameWidth);
    const isShow =
      viewPositionX + gameWidth + gameWidth >=
      this.x - this.width * 0.5 - this.width;

    if (!isShow) return;
    const playerHitArea = Player.hitArea;

    if (this.id === 101) {
      const hitAreaWidth = GameManager.calcRatio(HIT_AREA_WIDTH_101);
      const hitAreaHeight = GameManager.calcRatio(HIT_AREA_HEIGHT_101);
      const isCollisionObstacle = Intersects.ellipseBox(
        playerHitArea.x + viewPositionX,
        playerHitArea.y,
        playerHitArea.rx,
        playerHitArea.ry,
        this.hitArea.x,
        this.hitArea.y,
        hitAreaWidth,
        hitAreaHeight
      );
      if (isCollisionObstacle) this._hit();
    } else {
      if (this.id === 111 || this.id === 121) {
        const x = 1;
        this.sprite.x -= x;
        this.hitArea.x -= x;
      }
      if (this.id === 112 || this.id === 122) {
        const x = 2;
        this.sprite.x -= x;
        this.hitArea.x -= x;
      }

      if (this.id === 123) {
        const x = 1;
        const y = 0.4;
        this.sprite.x -= x;
        this.hitArea.x -= x;

        if (!this.isTurn && this.y <= 80) this.isTurn = true;
        if (this.isTurn) {
          this.sprite.y += y;
          this.hitArea.y += y;
        } else {
          this.sprite.y -= y;
          this.hitArea.y -= y;
        }
      }

      if (this.id === 124) {
        const x = 1;
        const y = 0.4;
        this.sprite.x -= x;
        this.hitArea.x -= x;
        this.sprite.y += y;
        this.hitArea.y += y;

        if (!this.isTurn && this.y >= 560) this.isTurn = true;
        if (this.isTurn) {
          this.sprite.y -= y;
          this.hitArea.y -= y;
        } else {
          this.sprite.y += y;
          this.hitArea.y += y;
        }
      }

      const isCollisionEnemy = Intersects.ellipseCircle(
        playerHitArea.x + viewPositionX,
        playerHitArea.y,
        playerHitArea.rx,
        playerHitArea.ry,
        this.hitArea.x,
        this.hitArea.y,
        this.hitArea.radius
      );
      if (isCollisionEnemy) {
        this._hit();
      }
    }
  }

  _hit() {
    GameManager.hit();
  }
}
